<template>
    <div class="col-sm-12 nopads">
        <div class="col-sm-12 editor-form" @click.stop="">
            <h2 class="editor-header">{{ accountUpdate.id > 0 ? $t('account.edit') : $t('account.add') }}</h2>
            <div class="col-sm-12 form-data nopads">
            <div>
              <div
                class="title"
                label-for="name"
              >
                <span class="span-title">{{ $t('account.account') }}</span>
                <input
                  id="unit"
                  v-model="accountUpdate.name"
                  :placeholder="$t('account.name')"
                  class="form-control form-control-mb"
                  type="text"
                >
              </div>
            </div>

      <div>
          <div
              class="title"
              label-for="code"
          >
              <span class="span-title">{{ $t('account.account_number') }}</span>
              <input
                  id="code"
                  v-model="accountUpdate.code"
                  :placeholder="$t('account.code')"
                  class="form-control form-control-mb"
                  type="text"
              >
          </div>
      </div>

          <div class="col-sm-4 nopads px-2">
              <span class="span-title">{{ $t('account.active') }}</span>
              <div>
                  <input
                      type="checkbox"
                      class="form-check-input pt-2"
                      v-model="accountUpdate.active"
                      style="margin-top: .5em; margin-right: .5em"
                      id="active"
                  />
              </div>
          </div>

          <div class="col-sm-4 nopads px-2">
              <span class="span-title">{{ $t('account.sanction_account') }}</span>
              <div>
                  <input
                      type="checkbox"
                      class="form-check-input pt-2"
                      v-model="accountUpdate.sanction_account"
                      style="margin-top: .5em; margin-right: .5em"
                      id="sanctionAccount"
                  />
              </div>
          </div>

        <div class="col-sm-12 button-container">
          <button class="btn btn-secondary form-button" @click.stop="$emit('close')">
            {{ $t('common.cancel') }}
          </button>
          <button class="btn btn-success form-button" :disabled="!!loading" @click.stop="submit">
            {{ $t('common.save') }}
          </button>
        </div>
      </div>
        </div>
        <div
          v-if="!!loading"
          id="loader"
          class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {accountHelper} from "@/components/mixins/AccountMixin"
import {inject} from "vue";

export default {
    name: 'AccountEditor',
    mixins: [restApi, accountHelper],
    props: {
        isSuperUser: Boolean,
        account: {
            type: Object,
            default: null
        }
    },
    emits: ['close', 'closeAndUpdate'],
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: 0,
            accountUpdate: this.newAccount(this.account),
        }
    },


    mounted: function () {
        this.accountUpdate = this.newAccount(this.account)
    },

    methods: {
        submit: function () {
            this.loading++
            if (this.accountUpdate.id > 0) {
                this.restUpdate(this.accountUrl, this.accountUpdate, this.success, this.fail)
            } else {
                this.restAdd(this.accountUrl, this.accountUpdate, this.success, this.fail)
            }
        },
        success: function () {
            this.loading--
            this.$emit('closeAndUpdate')
        },
        fail: function () {
            this.loading--
            if (this.accountUpdate.id < 0) {
                this.showAlert(this.$t('common.alert_add_failed'))
            } else {
                this.showAlert(this.$t('common.alert_update_failed'))
            }
        },
    }
}
</script>
